// extracted by mini-css-extract-plugin
export default {"loader":"Sr_lXD"};